var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajesticonsArticleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.6663H22.6667M20 15.9997H22.6667M22.6667 21.333H9.33333M9.33333 10.6663V15.9997H14.6667V10.6663H9.33333ZM6.66667 26.6663H25.3333C26.0406 26.6663 26.7189 26.3854 27.219 25.8853C27.719 25.3852 28 24.7069 28 23.9997V7.99967C28 7.29243 27.719 6.61415 27.219 6.11406C26.7189 5.61396 26.0406 5.33301 25.3333 5.33301H6.66667C5.95942 5.33301 5.28115 5.61396 4.78105 6.11406C4.28095 6.61415 4 7.29243 4 7.99967V23.9997C4 24.7069 4.28095 25.3852 4.78105 25.8853C5.28115 26.3854 5.95942 26.6663 6.66667 26.6663Z",
    stroke: "#464646",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsArticleLine);
export default __webpack_public_path__ + "static/media/majesticons_article-line.3580233a341ee35bfa5c9dac9bd62f81.svg";
export { ForwardRef as ReactComponent };